export const eventNames = {
  Templates_Clicked_TemplateCard: 'Templates_Clicked_TemplateCard',
  Templates_Clicked_FormatFilter: 'Templates_Clicked_FormatFilter',
  Templates_Clicked_CategoryFilter: 'Templates_Clicked_CategoryFilter',
  Templates_Deselected_CategoryFilter: 'Templates_Deselected_CategoryFilter',
  Templates_Reset_CategoryFilter: 'Templates_Reset_CategoryFilter',
  Templates_Clicked_SeeMoreFormats: 'Templates_Clicked_SeeMoreFormats',
  Templates_Clicked_SeeMoreCategories: 'Templates_Clicked_SeeMoreCategories',
  Templates_Clicked_SeeAllTemplates: 'Templates_Clicked_SeeAllTemplates',
  Templates_Clicked_CustomizationOptionsFilter: 'Templates_Clicked_CustomizationOptionsFilter',
  Templates_Clicked_PrintOptionsFilter: 'Templates_Clicked_PrintOptionsFilter',
  Templates_Uploaded_TemplateLogo: 'Templates_Uploaded_TemplateLogo',
  Templates_Input_ScanDestination: 'Templates_Input_ScanDestination',
  Templates_Clicked_UploadScanDestinationFile: 'Templates_Clicked_UploadScanDestinationFile',
  Templates_Clicked_SignUp: 'Templates_Clicked_SignUp',
  Templates_Clicked_TemplateSizeButton: 'Templates_Clicked_TemplateSizeButton',
  Templates_Clicked_SelectFlowcodeButton: 'Templates_Clicked_SelectFlowcodeButton',
  Templates_Clicked_FlowcodeInSelectFlowcodeModal:
    'Templates_Clicked_FlowcodeInSelectFlowcodeModal',
  Templates_Clicked_OrderPrintButton: 'Templates_Clicked_OrderPrintButton',
  Templates_Clicked_DownloadTemplateButton: 'Templates_Clicked_DownloadTemplateButton',
  Templates_Clicked_EmailTemplateButton: 'Templates_Clicked_EmailTemplateButton',
  Templates_Clicked_PrintTemplateButton: 'Templates_Clicked_PrintTemplateButton',
  Core_TemplatesEditor_Typed_InputtedText: 'Core_TemplatesEditor_Typed_InputtedText',
  Core_TemplatesEditor_Clicked_BackButton: 'Core_TemplatesEditor_Clicked_BackButton',
  Templates_Clicked_Template_FAQs_Button: 'Templates_Clicked_Template_FAQs_Button',
  Templates_Editor_Clicked_RemoveFlowcodeButton: 'Templates_Editor_Clicked_RemoveFlowcodeButton',
  Templates_Clicked_Load_More_Button: 'Templates_Clicked_Load_More_Button',
  PrintTemplates_TemplateStore_Viewed_SignUpModal:
    'PrintTemplates_TemplateStore_Viewed_SignUpModal',
  PrintTemplates_TemplateStore_Signupmodal_Clicked_GetStartedButton:
    'PrintTemplates_TemplateStore_Signupmodal_Clicked_GetStartedButton',
  Store_Templates_TemplateEditor_Clicked_Create_Flowcode_Btn:
    'Store_Templates_TemplateEditor_Clicked_Create_Flowcode_Btn',
  Store_Templates_TemplateEditor_Project_Data_Changed:
    'Store_Templates_TemplateEditor_Project_Data_Changed',
  Templates_YourTemplates_Flowpages_Clicked_CardPermissionInfo:
    'Templates_YourTemplates_Flowpages_Clicked_CardPermissionInfo',
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_CardPermissionInfo:
    'Templates_YourTemplates_All_FlowpageTemplates_Clicked_CardPermissionInfo',
  Templates_Discover_Flowcodes_Clicked_ShowMoreButton:
    'Templates_Discover_Flowcodes_Clicked_ShowMoreButton',
  Templates_Discover_Flowcodes_Clicked_Template: 'Templates_Discover_Flowcodes_Clicked_Template',
  Templates_Discover_Flowpages_Clicked_Template: 'Templates_Discover_Flowpages_Clicked_Template',
  Templates_Discover_Flowpages_Clicked_CardPermissionInfo:
    'Templates_Discover_Flowpages_Clicked_CardPermissionInfo',
  Templates_Discover_Flowpages_Clicked_ShowMoreButton:
    'Templates_Discover_Flowpages_Clicked_ShowMoreButton',
  Templates_Discover_Flowpages_Clicked_PreviewTemplateButton:
    'Templates_Discover_Flowpages_Clicked_PreviewTemplateButton',
  Templates_Discover_Flowpages_Clicked_UseTemplateButton:
    'Templates_Discover_Flowpages_Clicked_UseTemplateButton',
  Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAll:
    'Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAll',
  Templates_Discover_All_FlowpageTemplates_Clicked_SeeAll:
    'Templates_Discover_All_FlowpageTemplates_Clicked_SeeAll',
  Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAllCard:
    'Templates_Discover_All_FlowcodeTemplates_Clicked_SeeAllCard',
  Templates_Discover_All_FlowpageTemplates_Clicked_SeeAllCard:
    'Templates_Discover_All_FlowpageTemplates_Clicked_SeeAllCard',
  Templates_Discover_All_FlowcodeTemplates_Clicked_Template:
    'Templates_Discover_All_FlowcodeTemplates_Clicked_Template',
  Templates_Discover_All_FlowpageTemplates_Clicked_Template:
    'Templates_Discover_All_FlowpageTemplates_Clicked_Template',
  Templates_Discover_All_FlowpageTemplates_Clicked_CardPermissionInfo:
    'Templates_Discover_All_FlowpageTemplates_Clicked_CardPermissionInfo',
  Templates_Discover_All_FlowpageTemplates_Clicked_PreviewTemplateButton:
    'Templates_Discover_All_FlowpageTemplates_Clicked_PreviewTemplateButton',
  Templates_Discover_All_FlowpageTemplates_ClickedUseTemplateButton:
    'Templates_Discover_All_FlowpageTemplates_ClickedUseTemplateButton',
  Templates_Discover_All_FlowcodeTemplates_Clicked_ScrollArrow:
    'Templates_Discover_All_FlowcodeTemplates_Clicked_ScrollArrow',
  Templates_Discover_All_FlowpageTemplates_Clicked_ScrollArrow:
    'Templates_Discover_All_FlowpageTemplates_Clicked_ScrollArrow',
  Templates_Discover_Placements_PopularTemplates_Clicked_SeeAll:
    'Templates_Discover_Placements_PopularTemplates_Clicked_SeeAll',
  Templates_Discover_All_Placements_Templates_Clicked_SeeAllCard:
    'Templates_Discover_All_Placements_Templates_Clicked_SeeAllCard',
  Templates_Discover_All_Placements_Templates_Clicked_SeeAll:
    'Templates_Discover_All_Placements_Templates_Clicked_SeeAll',
  Templates_Discover_All_Placements_Templates_Clicked_Template:
    'Templates_Discover_All_Placements_Templates_Clicked_Template',
  Templates_Discover_All_Placements_Templates_Clicked_ScrollArrow:
    'Templates_Discover_All_Placements_Templates_Clicked_ScrollArrow',
  Templates_Discover_Placements_Products_Clicked_SeeAll:
    'Templates_Discover_Placements_Products_Clicked_SeeAll',
  Templates_Discover_Placements_Products_Clicked_SeeAllCard:
    'Templates_Discover_Placements_Products_Clicked_SeeAllCard',
  Templates_Discover_Placements_Products_Clicked_Product:
    'Templates_Discover_All_Placements_Products_Clicked_SeeAllCard',
  Templates_Discover_Placements_Products_Clicked_ScrollArrow:
    'Templates_Discover_Placements_Products_Clicked_ScrollArrow',
  Templates_Discover_Placements_PopularTemplates_Clicked_SeeAllCard:
    'Templates_Discover_Placements_PopularTemplates_Clicked_SeeAllCard',
  Templates_Discover_Placements_PopularTemplates_Clicked_Template:
    'Templates_Discover_Placements_PopularTemplates_Clicked_Template',
  Templates_Discover_Placements_PopularTemplates_Clicked_ScrollArrow:
    'Templates_Discover_Placements_PopularTemplates_Clicked_ScrollArrow',
  Templates_Mobile_TopNav_Clicked_BackArrow: 'Templates_Mobile_TopNav_Clicked_BackArrow',
  Templates_Mobile_TopNav_Clicked_SwitchButton: 'Templates_Mobile_TopNav_Clicked_SwitchButton',
  Templates_Mobile_TopNav_Clicked_TabMenu: 'Templates_Mobile_TopNav_Clicked_TabMenu',
  Templates_Mobile_TopNav_Clicked_CreateTemplatePlusButton:
    'Templates_Mobile_TopNav_Clicked_CreateTemplatePlusButton',
  Templates_CreateTemplateMenu_Clicked_FlowcodeTemplate:
    'Templates_CreateTemplateMenu_Clicked_FlowcodeTemplate',
  Templates_CreateTemplateMenu_Clicked_FlowpageTemplate:
    'Templates_CreateTemplateMenu_Clicked_FlowpageTemplate',
  Templates_CreateTemplateMenu_Clicked_RequestCustomCode:
    'Templates_CreateTemplateMenu_Clicked_RequestCustomCode',
  Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_RenameButton:
    'Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_RenameButton',
  Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_CancelButton:
    'Templates_YourTemplates_Flowpage_RenameTemplate_Clicked_CancelButton',
  Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_DeleteButton:
    'Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_DeleteButton',
  Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_CancelButton:
    'Templates_YourTemplates_Flowpage_DeleteTemplate_Clicked_CancelButton',
  Templates_YourTemplates_All_Clicked_Flowcodes_SeeAll:
    'Templates_YourTemplates_All_Clicked_Flowcodes_SeeAll',
  Templates_YourTemplates_All_Clicked_Flowcodes_SeeAllCard:
    'Templates_YourTemplates_All_Clicked_Flowcodes_SeeAllCard',
  Templates_YourTemplates_All_FlowcodeTemplates_Clicked_ScrollArrow:
    'Templates_YourTemplates_All_FlowcodeTemplates_Clicked_ScrollArrow',
  Templates_YourTemplates_All_FlowcodeTemplates_Clicked_Template:
    'Templates_YourTemplates_All_FlowcodeTemplates_Clicked_Template',
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_PreviewTemplateButton:
    'Templates_YourTemplates_All_FlowpageTemplates_Clicked_PreviewTemplateButton',
  Templates_YourTemplates_All_FlowpageTemplates_ClickedUseTemplateButton:
    'Templates_YourTemplates_All_FlowpageTemplates_ClickedUseTemplateButton',
  Templates_YourTemplates_All_Clicked_CreateTemplateButton:
    'Templates_YourTemplates_All_Clicked_CreateTemplateButton',
  Templates_YourTemplates_All_Clicked_Flowpages_SeeAll:
    'Templates_YourTemplates_All_Clicked_Flowpages_SeeAll',
  Templates_YourTemplates_All_Clicked_Flowpages_SeeAllCard:
    'Templates_YourTemplates_All_Clicked_Flowpages_SeeAllCard',
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_ScrollArrow:
    'Templates_YourTemplates_All_FlowpageTemplates_Clicked_ScrollArrow',
  Templates_YourTemplates_All_FlowpageTemplates_Clicked_Template:
    'Templates_YourTemplates_All_FlowpageTemplates_Clicked_Template',
  Templates_YourTemplates_Flowpages_Clicked_CardMenuButton:
    'Templates_YourTemplates_Flowpages_Clicked_CardMenuButton',
  Templates_YourTemplates_Flowpages_Clicked_CardMenuPreviewButton:
    'Templates_YourTemplates_Flowpages_Clicked_CardMenuPreviewButton',
  Templates_YourTemplates_Flowpages_Clicked_CardMenuUseTemplateButton:
    'Templates_YourTemplates_Flowpages_Clicked_CardMenuUseTemplateButton',
  Templates_YourTemplates_Flowpages_Clicked_CardMenuShare:
    'Templates_YourTemplates_Flowpages_Clicked_CardMenuShare',
  Templates_YourTemplates_Flowpages_Clicked_CardMenuRename:
    'Templates_YourTemplates_Flowpages_Clicked_CardMenuRename',
  Templates_YourTemplates_Flowpages_Clicked_CardMenuDelete:
    'Templates_YourTemplates_Flowpages_Clicked_CardMenuDelete',
  Templates_YourTemplates_Flowpages_Clicked_CardMenuEdit:
    'Templates_YourTemplates_Flowpages_Clicked_CardMenuEdit',
  Templates_YourTemplates_Flowpages_Clicked_PreviewTemplateButton:
    'Templates_YourTemplates_Flowpages_Clicked_PreviewTemplateButton',
  Templates_YourTemplates_Flowpages_Clicked_UseTemplateButton:
    'Templates_YourTemplates_Flowpages_Clicked_UseTemplateButton',
  Templates_YourTemplates_Flowpages_Clicked_CreatePageTemplateButton:
    'Templates_YourTemplates_Flowpages_Clicked_CreatePageTemplateButton',
  Templates_YourTemplates_Flowpages_Clicked_TemplateCard:
    'Templates_YourTemplates_Flowpages_Clicked_TemplateCard',
  Templates_YourTemplates_Flowpages_Clicked_SearchButton:
    'Templates_YourTemplates_Flowpages_Clicked_SearchButton',
  Templates_YourTemplates_Flowpages_Searched_Templates:
    'Templates_YourTemplates_Flowpages_Searched_Templates',
  Templates_YourTemplates_Flowpages_Clicked_ClearSearchButton:
    'Templates_YourTemplates_Flowpages_Clicked_ClearSearchButton',
  Templates_YourTemplates_Flowpages_Clicked_SearchDoneButton:
    'Templates_YourTemplates_Flowpages_Clicked_SearchDoneButton',
  Templates_YourTemplates_Flowpages_Clicked_ShowMoreButton:
    'Templates_YourTemplates_Flowpages_Clicked_ShowMoreButton',
  Templates_YourTemplates_Flowpages_Clicked_TemplatesTypeFilterChip:
    'Templates_YourTemplates_Flowpages_Clicked_TemplatesTypeFilterChip',
  Templates_YourTemplates_Flowpages_Clicked_SortByButton:
    'Templates_YourTemplates_Flowpages_Clicked_SortByButton',
  Templates_YourTemplates_Flowpages_Clicked_SortDirectionButton:
    'Templates_YourTemplates_Flowpages_Clicked_SortDirectionButton',
  Templates_YourTemplates_Flowpages_Clicked_SortOption:
    'Templates_YourTemplates_Flowpages_Clicked_SortOption',
  Templates_YourTemplates_Flowpages_Clicked_CreateAFlowpageTemplateButton:
    'Templates_YourTemplates_Flowpages_Clicked_CreateAFlowpageTemplateButton',
  Templates_YourTemplates_Flowcodes_Clicked_TemplatesTypeFilterChip:
    'Templates_YourTemplates_Flowcodes_Clicked_TemplatesTypeFilterChip',
  Templates_YourTemplates_Flowcodes_Clicked_CreateCodeTemplateButton:
    'Templates_YourTemplates_Flowcodes_Clicked_CreateCodeTemplateButton',
  Templates_YourTemplates_Flowcodes_Clicked_CreateAFlowcodeTemplateButton:
    'Templates_YourTemplates_Flowcodes_Clicked_CreateAFlowcodeTemplateButton',
  Templates_YourTemplates_Flowcodes_Clicked_Template:
    'Templates_YourTemplates_Flowcodes_Clicked_Template',
  Templates_CreateCodeTemplateModal_Selected_Flowcode:
    'Templates_CreateCodeTemplateModal_Selected_Flowcode',
  Templates_CreateCodeTemplateModal_Entered_TemplateName:
    'Templates_CreateCodeTemplateModal_Entered_TemplateName',
  Templates_CreateCodeTemplateModal_Clicked_Cancel_Button:
    'Templates_CreateCodeTemplateModal_Clicked_Cancel_Button',
  Templates_CreateCodeTemplateModal_Clicked_CreateTemplateButton:
    'Templates_CreateCodeTemplateModal_Clicked_CreateTemplateButton',
  Templates_CreateCodeTemplateModal_Clicked_DismissButton:
    'Templates_CreateCodeTemplateModal_Clicked_DismissButton',
  Templates_CreateCodeTemplateModal_Clicked_CreateFlowcodeButton:
    'Templates_CreateCodeTemplateModal_Clicked_CreateFlowcodeButton',
  Templates_Create_Page_Template_Share_Modal_Clicked_ShareButton:
    'Templates_Create_Page_Template_Share_Modal_Clicked_ShareButton',
  Templates_Create_Page_Template_Share_Modal_Clicked_SearchInput:
    'Templates_Create_Page_Template_Share_Modal_Clicked_SearchInput',
  Templates_Create_Page_Template_Share_Modal_Selected_Permission:
    'Templates_Create_Page_Template_Share_Modal_Selected_Permission',
  Templates_Create_Page_Template_Share_Modal_Clicked_ShareWithEveryoneCheckbox:
    'Templates_Create_Page_Template_Share_Modal_Clicked_ShareWithEveryoneCheckbox',
  Templates_Create_Page_Template_Share_Modal_Clicked_PermissionDropdown:
    'Templates_Create_Page_Template_Share_Modal_Clicked_PermissionDropdown',
  Templates_CreatePageTemplateModal_Selected_Flowpage:
    'Templates_CreatePageTemplateModal_Selected_Flowpage',
  Templates_CreatePageTemplateModal_Entered_TemplateName:
    'Templates_CreatePageTemplateModal_Entered_TemplateName',
  Templates_CreatePageTemplateModal_Entered_Note: 'Templates_CreatePageTemplateModal_Entered_Note',
  Templates_CreatePageTemplateModal_Clicked_ShareTemplate:
    'Templates_CreatePageTemplateModal_Clicked_ShareTemplate',
  Templates_CreatePageTemplateModal_Clicked_SubmitCopy:
    'Templates_CreatePageTemplateModal_Clicked_SubmitCopy',
  Templates_CreatePageTemplateModal_Clicked_PropagateChanges:
    'Templates_CreatePageTemplateModal_Clicked_PropagateChanges',
  Templates_CreatePageTemplateModal_Clicked_CancelButton:
    'Templates_CreatePageTemplateModal_Clicked_CancelButton',
  Templates_CreatePageTemplateModal_Clicked_CreateTemplate_Button:
    'Templates_CreatePageTemplateModal_Clicked_CreateTemplate_Button',
  Templates_CreatePageTemplateModal_Clicked_DismissButton:
    'Templates_CreatePageTemplateModal_Clicked_DismissButton',
  Templates_CreatePageTemplateModal_Clicked_CreateFlowpageButton:
    'Templates_CreatePageTemplateModal_Clicked_CreateFlowpageButton',
  Templates_MaxAssetsAlert_Clicked_CreateMoreButton:
    'Templates_MaxAssetsAlert_Clicked_CreateMoreButton',
  Templates_YourCreate_Clicked_CreateCodeTemplateButton:
    'Templates_YourCreate_Clicked_CreateCodeTemplateButton',
  Templates_YourCreate_Clicked_CreatePageTemplateButton:
    'Templates_YourCreate_Clicked_CreatePageTemplateButton',
  Templates_YourCreate_Clicked_UpgradeToCreatePageTemplateButton:
    'Templates_YourCreate_Clicked_UpgradeToCreatePageTemplateButton',
  Templates_CreatePageTemplateModal_Creation_Success:
    'Templates_CreatePageTemplateModal_Creation_Success',
  Templates_CreateCodeTemplateModal_Creation_Success:
    'Templates_CreateCodeTemplateModal_Creation_Success'
}

export default eventNames
